<template>
    <div class="with-inline-website-assistant">
        <website-assistant
            :inline="true"
            from="sounds"
            :title="assistantTitle"
            :subtitle="assistantSubtitle"
            :text="assistantText"
        ></website-assistant>
        <section v-if="initialized" class="mb2">
            <input type="hidden" ref="gclid" id="gclid_field" name="gclid_field" value="">
            <div class="pad">
                <div class="wrap text-right">
                    <div v-if="loggedIn">
                        {{ window.t('sounds_your_credits') }}: <template>{{ credits }}</template> &nbsp; &nbsp;
                        <a class="btn" href="#" onclick="return toggleAccount();">{{ window.t('sounds_your_account_btn') }}</a>
                    </div>
                    <div v-else class="buttons">
                        <a class="btn outline-red" href="#" @click.prevent="openLogin">{{ window.t('sounds_login_btn') }}</a> &nbsp; &nbsp;
                        <a class="btn grey" :href="registerUrl">{{ window.t('sounds_create_account_btn') }}</a>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="initialized">
            <div class="pad">
                <div class="wrap">
                    <div class="sounds-picker for-sounds">
                        <div class="search">
                            <input type="text" :placeholder="window.t('sounds_searchbar')" v-model="search">
                            <a href="#" :class="['filter-toggle', {'filter-mobile-visible':filterMobileVisible}]" @click.prevent="toggleFilterMobile">
                                <img src="/images/filter.svg">
                            </a>
                        </div>
                        <div class="tags">
                            <ul v-if="search != '' || selectedGenres.length || selectedKeys.length || selectedMoods.length || selectedPriceGroups.length || selectedBundle != null">
                                <li class="tag" v-if="search != ''"><a href="#" @click.prevent="search = ''">{{ search }}</a></li>
                                <li class="tag" v-for="(selectedGenre, selectedGenreIndex) in selectedGenres" :key="'selected-genre-' + selectedGenreIndex"><a href="#" @click.prevent="toggleGenre(selectedGenre)">{{ selectedGenre.name }}</a></li>
                                <li class="tag" v-for="(selectedKey, selectedKeyIndex) in selectedKeys" :key="'selected-key-' + selectedKeyIndex"><a href="#" @click.prevent="toggleKey(selectedKey)">{{ selectedKey.name }}</a></li>
                                <li class="tag" v-for="(selectedMood, selectedMoodIndex) in selectedMoods" :key="'selected-mood-' + selectedMoodIndex"><a href="#" @click.prevent="toggleMood(selectedMood)">{{ selectedMood.name }}</a></li>
                                <li class="tag" v-for="(selectedPriceGroup, selectedPriceGroupIndex) in selectedPriceGroups" :key="'selected-price-group-' + selectedPriceGroupIndex"><a href="#" @click.prevent="togglePriceGroup(selectedPriceGroup)">{{ selectedPriceGroup.name }}</a></li>
                                <li class="tag" v-if="selectedBundle != null"><a href="#" @click.prevent="toggleBundle(selectedBundle)">{{ selectedBundle.name }}</a></li>
                                <li><a href="#" @click.prevent="resetFilter" class="reset">{{ window.t('general_reset_filter') }}</a></li>
                            </ul>
                        </div>
                        <div class="bundles" v-if="visibleBundles.length">
                            <div class="bundle" v-for="(bundle, bundleIndex) in shownBundles" :key="'bundle-' + bundleIndex" @click.prevent="selectBundle(bundle)" :class="{'active': isBundleActive(bundle)}">
                                <div v-if="bundle.image" class="image" :style="'background-image:url(\'/files/'+bundle.image+'\');'"></div>
                                <h4 class="label">{{ bundle.name }}</h4>
                                <div class="bundle-label">{{ window.t('sounds_bundle') }}</div>
                            </div>
                            <button v-if="bundlesTotalPages>1" @click.prevent="bundlesPrevPage()" class="scroll prev"><img src="/images/slider-right.svg" alt="Prev"></button>
                            <button v-if="bundlesTotalPages>1" @click.prevent="bundlesNextPage()" class="scroll next"><img src="/images/slider-right.svg" alt="Next"></button>
                        </div>
                        <div :class="['filter', {'filter-mobile-visible':filterMobileVisible}]">
                            <div class="filter-sticky">
                                <ul class="main" v-if="genres.length || keys.length || moods.length">
                                    <li v-if="genres.length"><a href="#" :class="{on: selectedFilter == 'genre'}" @click.prevent="selectedFilter = 'genre'">Genre</a></li>
                                    <li v-if="keys.length"><a href="#" :class="{on: selectedFilter == 'key'}" @click.prevent="selectedFilter = 'key'">Key</a></li>
                                    <li v-if="priceGroups.length"><a href="#" :class="{on: selectedFilter == 'pricegroups'}" @click.prevent="selectedFilter = 'pricegroups'">Type</a></li>
                                    <li v-if="visibleBundles.length"><a href="#" :class="{on: selectedFilter == 'bundle'}" @click.prevent="selectedFilter = 'bundle'">Bundle</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'genre'">
                                    <li v-for="genre in genres" :key="'genre-filter-' + genre.id"><a href="#" @click.prevent="toggleGenre(genre)" :class="{on: isGenreActive(genre)}">{{ genre.name }}</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'key'">
                                    <li v-for="key in keys" :key="'key-filter-' + key.id"><a href="#" @click.prevent="toggleKey(key)" :class="{on: isKeyActive(key)}">{{ key.name }}</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'mood'">
                                    <li v-for="mood in moods" :key="'mood-filter-' + mood.id"><a href="#" @click.prevent="toggleMood(mood)" :class="{on: isMoodActive(mood)}">{{ mood.name }}</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'pricegroups'">
                                    <li v-for="priceGroup in priceGroups" :key="'price-group-filter-' + priceGroup.id"><a href="#" @click.prevent="togglePriceGroup(priceGroup)" :class="{on: isPriceGroupActive(priceGroup)}">{{ priceGroup.name }}</a></li>
                                </ul>
                                <ul class="sub" v-if="selectedFilter == 'bundle'">
                                    <li v-for="bundle in visibleBundles" :key="'bundle-filter-' + bundle.id"><a href="#" @click.prevent="toggleBundle(bundle)" :class="{on: isBundleActive(bundle)}">{{ bundle.name }}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div ref="sounds" class="sounds">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="th-label hide-l"></th>
                                        <th></th>
                                        <th @click.prevent="toggleSort('title')" :class="getColumnHeaderClasses('title')">
                                            <span>Title</span>
                                        </th>
                                        <th @click.prevent="toggleSort('type')" :class="getColumnHeaderClasses('type')" class="hide-s">
                                            <span>Type</span>
                                        </th>
                                        <th @click.prevent="toggleSort('genre')" :class="getColumnHeaderClasses('genre')" class="hide-s">
                                            <span>Genre</span>
                                        </th>
                                        <th @click.prevent="toggleSort('bpm')" :class="getColumnHeaderClasses('bpm')" class="hide-m">
                                            <span>BPM</span>
                                        </th>
                                        <th @click.prevent="toggleSort('key')" :class="getColumnHeaderClasses('key')" class="hide-m">
                                            <span>Key</span>
                                        </th>
                                        <th class="hide-m">Moods</th>
                                        <th></th>
                                        <th @click.prevent="toggleSort('length')" :class="getColumnHeaderClasses('length')">
                                            <span>Length</span>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <!-- <th colspan="3" class="r">
                                            <select class="sort" v-model="sort">
                                                <option :value="null">Sort by...</option>
                                                <option value="title">Title</option>
                                                <option value="key">Key</option>
                                                <option value="genre">Genre</option>
                                                <option value="length">Length</option>
                                            </select>
                                        </th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="results.length">
                                        <template v-for="(result, resultIndex) in results">
                                            <tr :class="[result.children.length ? 'child-row top-row' : '', result.children.length && !soundExpanded(result) ? 'bottom-row' : '']" :key="'result-row-' + resultIndex + '-jingle-' + result.id" :id="'sound-result-item-' + result.id">
                                                <td class="hide-l"><div class="label" v-if="result.new">New</div></td>
                                                <td><play-button :player-id="'sounds-results-' + result.id" :file-id="result.id" :description="result.name"></play-button></td>
                                                <td>{{ result.name }}</td>
                                                <td class="hide-s">{{ result.priceGroup }}</td>
                                                <td class="hide-s">{{ result.genre }}</td>
                                                <td class="hide-m">{{ result.bpm }}</td>
                                                <td class="hide-m">{{ result.key }}</td>
                                                <td class="hide-m">{{ result.moods }}</td>
                                                <td class="waveform-td"><player :player-id="'sounds-results-' + result.id" :file-id="result.id" wave-form-image-template="frontend_jinglebox" :totalTime="result.duration"></player></td>
                                                <td class="hide-m">{{ result.duration_string }}</td>
                                                <td class="with-actions">
                                                    <div class="actions">
                                                        <a href="#" v-if="result.children.length" :class="['expand-children', {on: soundExpanded(result) }]" @click.prevent="toggleSoundExpand(result)"></a>
                                                        <a href="#" class="download" @click.prevent="download(result.id)" v-if="result.owned"></a>
                                                        <a href="#" class="in-cart with-tooltip" v-else @click.prevent="selectSound(resultIndex)">
                                                            <div class="tooltip">{{ result.credits }} credit{{ result.credits==1 ? '' : 's' }}</div>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <template v-if="result.children.length && soundExpanded(result)">
                                                <tr v-for="(child, childIndex) in result.children" :key="'result-row-' + resultIndex + '-sound-' + result.id + '-child-' + childIndex + '-child-' + child.id" class="child-row" :class="childIndex == result.children.length - 1 ? 'bottom-row' : ''">
                                                    <td class="hide-l"><div class="label" v-if="child.new">New</div></td>
                                                    <td><play-button :player-id="'sounds-results-' + child.id" :file-id="child.id" :description="child.name"></play-button></td>
                                                    <td>{{ child.name }}</td>
                                                    <td class="hide-s">{{ child.priceGroup }}</td>
                                                    <td class="hide-s">{{ child.genre }}</td>
                                                    <td class="hide-m">{{ child.bpm }}</td>
                                                    <td class="hide-m">{{ child.key }}</td>
                                                    <td class="hide-m">{{ child.moods }}</td>
                                                    <td class="waveform-td"><player :player-id="'sounds-results-' + child.id" :file-id="child.id" wave-form-image-template="frontend_jinglebox" :totalTime="child.duration"></player></td>
                                                    <td class="hide-m">{{ child.duration_string }}</td>
                                                    <td class="with-actions">
                                                        <div class="actions">
                                                            <a href="#" class="download" @click.prevent="download(child.id)" v-if="child.owned"></a>
                                                            <a href="#" class="in-cart with-tooltip" v-else @click.prevent="selectVariant(resultIndex,childIndex)">
                                                                <div class="tooltip">{{ child.credits }} credit{{ child.credits==1 ? '' : 's' }}</div>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>
                                    <tr v-else>
                                        <td colspan="13">{{ window.t('general_no_results') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="selectedBundle != null" class="buy-bundle-btn-container">
                                <a class="btn" v-if="selectedBundleNotOwnedItems.length > 0" href="#" @click.prevent="toggleBundleCheckout">{{ window.t('sounds_buy_bundle') }}<template v-if="selectedBundle.discount > 0"> at a {{ selectedBundle.discount }}% discount</template></a>
                                <a v-else-if="selectedBundleOwnedItems.length > 0" href="#" @click.prevent="downloadBundle">{{ window.t('sounds_download') }}</a>
                            </div>
                            <div class="pager" v-if="totalPages > 1">
                                <a href="#" v-if="currentPage > 1" @click.prevent="goToPrevPage">
                                    <span class="full">{{ window.t('general_previous') }}</span>
                                    <span class="compact">&lt;</span>
                                </a>
                                <span class="current-page">
                                    <input type="text" :value="currentPage" disabled="disabled">
                                    {{ window.t('general_step') }} {{ totalPages }}
                                </span>
                                <a href="#" v-if="currentPage < totalPages" @click.prevent="goToNextPage">
                                    <span class="full">{{ window.t('general_next') }}</span>
                                    <span class="compact">&gt;</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="showSoundError">
			<div class="bg" @click.prevent="closeSoundError"></div>
			<div class="panel-scroller">
				<div class="panel small">
					<a href="#" class="close" @click.prevent="closeSoundError"></a>
					<form class="form">
						<div class="modal-head">
							<h2 class="h2">Pure Sounds</h2>
							<h3 class="h2 black">&nbsp;</h3>
						</div>
						<div class="modal-body">
							<div class="step">
                                <div class="sounds-message">
                                    <template>
                                        {{ window.t('sounds_upgrade') }}
                                    </template>
                                </div>
							</div>
						</div>
						<div class="modal-foot">
                            <span></span>
                            <a href="#" :class="['btn', 'w180']" @click.prevent="closeSoundError">Close</a>
						</div>
					</form>
				</div>
			</div>
		</section>
        <section class="modal checkout" v-if="showBundleCheckout">
			<div class="bg" @click.prevent="toggleBundleCheckout"></div>
			<div class="panel-scroller">
				<div class="panel">
					<a href="#" class="close" @click.prevent="toggleBundleCheckout"></a>
					<form class="form">
						<div class="modal-head">
							<h2 class="h2">Pure Sounds</h2>
							<h3 class="h2 black" v-if="!orderCompleted">{{ window.t('sounds_buy_bundle') }}</h3>
							<h3 class="h2 black" v-else>{{ window.t('general_work') }}</h3>
						</div>
						<div class="modal-body">
							<div class="step" v-if="orderCompleted">
                                <a href="#" @click.prevent="downloadBundle">{{ window.t('sounds_download_confirm')}}</a>
							</div>
							<div class="step" v-else>
                                <template v-if="selectedBundleNotOwnedItems.length == 0">
                                    {{ window.t('sounds_already_own') }}
                                </template>
                                <template v-else-if="selectedBundlePrice > credits">
                                    {{ window.t('sounds_no_credits') }}
                                </template>
                                <template v-else>
                                    <div v-if="selectedBundleOwnedItems == 0">
                                    {{ window.t('sounds_buy_bundle_for', false, {'selectedBundlePrice': selectedBundlePrice}) }}<br>
                                    </div>
                                    <div v-else>
                                    {{ window.t('sounds_cost_bundle', false, {'selectedBundlePrice': selectedBundlePrice}) }}<br>
                                    {{ window.t('sounds_buy_bundle_owned', false, {'selectedBundlePrice': selectedBundlePriceWithoutOwned, 'ownedItems': selectedBundleOwnedItems.length}) }}<br>
                                    </div>
                                    {{ window.t('sounds_current_credits', false, {'credits': credits}) }}
                                </template>
							</div>
						</div>
						<div class="modal-foot">
                            <a href="#" :class="['btn', 'w180']" @click.prevent="toggleBundleCheckout" v-if="orderCompleted">{{ window.t('general_close') }}</a>
                            <a href="#" :class="['btn', 'w180', 'secondary']" @click.prevent="toggleBundleCheckout" v-else>{{ window.t('general_cancel') }}</a>

							<a href="#" v-if="!orderCompleted && selectedBundleNotOwnedItems.length > 0 && selectedBundlePrice <= credits" :class="['btn', 'w180']" @click.prevent="buyBundle">{{ window.t('sounds_buy_bundle') }}</a>
						</div>
					</form>
				</div>
			</div>
		</section>
    </div>
</template>


<script>
    export default {
        props: {
            itemsPerPage: {
                type: Number,
                default: 50,
            },
            defaultLanguage: {
                type: String,
                default: 'en',
            },
            language: {
                type: String,
                default: 'en',
            },
            basePath: {
                type: String,
                required: true,
            },
            preSelectedFilter: {
                type: String,
                default: '',
            },
            highlightedBundleIds: {
                default() {
                    return {}
                },
            },
            assistantTitle: {
                type: String,
                default: null,
            },
            assistantSubtitle: {
                type: String,
                default: null,
            },
            assistantText: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                window,
                initialized: false,
                loggedIn: false,
                search: '',
                selectedBundle: null,
                showBundleCheckout: false,
                searchTimeout: null,
                expandedSounds: [],
                genres: [],
                keys: [],
                moods: [],
                priceGroups: [],
                bundles: [],
                highlightedBundles: [],
                selectedGenres: [],
                selectedKeys: [],
                selectedMoods: [],
                selectedPriceGroups: [],
                results: [],
                selectedFilter: null,
                currentPage: 1,
                totalItems: 0,
                totalPages: 0,
                expandedJingles: [],
                watchRoute: true,
                requestPath: true,
                sort: null,
                sortDirection: 'asc',
                orderCompleted: false,
                credits: 0,
                filterMobileVisible: false,
                registerUrl: '/',
                showSoundError: false,
                bundlesPerPage: 6,
                bundlesPageIndex: 0,
            }
        },
        watch: {
            search(newValue,oldValue) {
                if (this.initialized) {

                    this.selectedBundle = null;
                    this.debounceSearch();
                }
            },
            watchValue(newValue,oldValue) {
                if (this.initialized) {
                    this.goToPath();
                }
            },
            '$route' (to, from) {
				if (to.path != from.path && this.watchRoute && this.initialized) {
                    this.initialized = false;
					this.fetchData(1);
				}
			},
        },
        methods: {
            soundExpanded(sound) {
                return this.expandedSounds.includes(sound.id);
            },
            toggleSoundExpand(sound) {
                let foundIndex = null;

                for (let e in this.expandedSounds) {
                    if (this.expandedSounds[e] == sound.id) {
                        foundIndex = e;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.expandedSounds.push(sound.id);
                } else {
                    this.expandedSounds.splice(foundIndex, 1);
                }
            },
            downloadBundle() {
                document.location = '/sounds/download/bundle/' + this.selectedBundle.id;
            },
            selectSound(index) {
                if (!this.loggedIn) {
                    toggleAccount(this.results[index].id);
                    return false;
                }

                this.buy(this.results[index].id);
            },
            selectVariant(soundIndex,index) {
                if (!this.loggedIn) {
                    toggleAccount(this.results[soundIndex].children[index].id);
                    return false;
                }

                this.buyVariant(this.results[soundIndex].id, this.results[soundIndex].children[index].id);
            },
            openLogin() {
                toggleAccount();
            },
            toggleBundleCheckout() {
                if (!this.loggedIn) {
                    toggleAccount();
                    return false;
                }

                this.orderCompleted = false;
                this.showBundleCheckout = !this.showBundleCheckout;
                $html.toggleClass('modal-visible');
            },
            download(id) {
                let url = '/sounds/download/' + id;
                let params = new URLSearchParams;

                if (this.$refs.gclid && this.$refs.gclid.value) {
                    params.append('gclid', this.$refs.gclid.value);
                    // url += '?gclid=' + encodeURIComponent(this.$refs.gclid.value);
                }

                params.append('referrer', document.location);

                document.location = url + '?' + params.toString();
            },
            async buy(id = null) {
                await axios
                    .post('/sounds/buy/' + id)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            if (response.data.success) {
                                this.orderCompleted = true;

                                for (let r in this.results) {
                                    if (this.results[r].id == id) {
                                        this.$set(this.results[r], 'owned', true);
                                    }
                                }

                                this.download(id)
                            } else {
                                this.showSoundError = true;
                            }

                            this.credits = response.data.credits;
                        }

                    });
            },
            async buyVariant(soundId, id) {
                await axios
                    .post('/sounds/buy/' + id)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            if (response.data.success) {
                                this.orderCompleted = true;
                                for (let r in this.results) {
                                    if (this.results[r].id != soundId) {
                                        continue;
                                    }

                                    for (let c in this.results[r].children) {
                                        if (this.results[r].children[c].id == id) {
                                            this.$set(this.results[r].children[c], 'owned', true);
                                        }
                                    }
                                }

                                this.download(id)
                            } else {
                                this.showSoundError = true;
                            }

                            this.credits = response.data.credits;
                        }

                    });
            },
            async buyBundle() {
                await axios
                    .post('/sounds/buy/bundle/' + this.selectedBundle.id)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            if (response.data.success) {
                                this.orderCompleted = true;

                                for (let r in this.results) {
                                    if (_.includes(response.data.owned, this.results[r].id)) {
                                        this.$set(this.results[r], 'owned', true);
                                    }
                                }

                                this.downloadBundle();
                            }

                            this.credits = response.data.credits;
                        }

                    });
            },
            closeSoundError() {
                this.showSoundError = false;
                $html.removeClass('modal-visible');
            },
            goToPath: async function (fetchData = true) {

                this.watchRoute = false;
                let goToPath = '/' + this.basePath;

                if (this.selectedGenres.length || this.selectedKeys.length || this.selectedMoods.length || this.selectedPriceGroups.length || this.search != '' || this.selectedBundle != null || this.sort != null ) {
                    const seperator = '||-||'

                    let string = 'search=' + this.search + seperator + 'genres=';

                    for (let g in this.selectedGenres) {
                        string += this.selectedGenres[g].id + (g < this.selectedGenres.length -1 ? ',' : '');
                    }

                    string += seperator + 'keys=';

                    for (let t in this.selectedKeys) {
                        string += this.selectedKeys[t].id + (t < this.selectedKeys.length - 1 ? ',' : '');
                    }

                    string += seperator + 'moods=';

                    for (let t in this.selectedMoods) {
                        string += this.selectedMoods[t].id + (t < this.selectedMoods.length - 1 ? ',' : '');
                    }

                    string += seperator + 'pricegroups=';

                    for (let t in this.selectedPriceGroups) {
                        string += this.selectedPriceGroups[t].id + (t < this.selectedPriceGroups.length - 1 ? ',' : '');
                    }

                    string += seperator + 'bundle=' + (this.selectedBundle == null ? '' : this.selectedBundle.id);

                    string += seperator + 'sort=' + (this.sort ? this.sort : '');

                    string += seperator + 'sortDirection=' + this.sortDirection;

                    const amountSelectedPriceGroups = this.selectedPriceGroups.length;

                    goToPath = (this.basePath ? '/' + this.basePath : '') + (amountSelectedPriceGroups == 1 ? '/' + this.selectedPriceGroups[0].alias : '') + '#' + btoa(string);
                }

                if (goToPath != this.$route.fullPath) {
                    await router.push(goToPath);

                    if (fetchData) {
                        this.fetchData(1);
                    }
                }

                this.watchRoute = true;

            },
            resetFilter() {
                this.search = '';
                this.selectedGenres = [];
                this.selectedKeys = [];
                this.selectedMoods = [];
                this.selectedPriceGroups = [];
                this.selectedBundle = null;
            },
            debounceSearch(){
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                }

                this.searchTimeout = setTimeout(() => {
                    this.goToPath();
                }, 400);
            },
            toggleGenre(genre) {
                let foundIndex = null;


                for (let g in this.selectedGenres) {
                    if (this.selectedGenres[g].id == genre.id) {
                        foundIndex = g;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.selectedGenres.push(_.clone(genre));
                } else {
                    this.selectedGenres.splice(foundIndex, 1);
                }

                this.selectedBundle = null;
            },
            isGenreActive(genre) {
                let found = false;

                for (let g in this.selectedGenres) {
                    if (this.selectedGenres[g].id == genre.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            toggleKey(key) {
                let foundIndex = null;

                for (let g in this.selectedKeys) {
                    if (this.selectedKeys[g].id == key.id) {
                        foundIndex = g;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.selectedKeys.push(_.clone(key));
                } else {
                    this.selectedKeys.splice(foundIndex, 1);
                }

                this.selectedBundle = null;
            },
            isKeyActive(key) {
                let found = false;

                for (let g in this.selectedKeys) {
                    if (this.selectedKeys[g].id == key.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            toggleMood(mood) {
                let foundIndex = null;

                for (let g in this.selectedMoods) {
                    if (this.selectedMoods[g].id == mood.id) {
                        foundIndex = g;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.selectedMoods.push(_.clone(mood));
                } else {
                    this.selectedMoods.splice(foundIndex, 1);
                }

                this.selectedBundle = null;
            },
            isMoodActive(mood) {
                let found = false;

                for (let g in this.selectedMoods) {
                    if (this.selectedMoods[g].id == mood.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            togglePriceGroup(priceGroup) {
                let foundIndex = null;

                for (let v in this.selectedPriceGroups) {
                    if (this.selectedPriceGroups[v].id == priceGroup.id) {
                        foundIndex = v;
                        break;
                    }
                }

                if (foundIndex === null) {
                    this.selectedPriceGroups.push(_.clone(priceGroup));
                } else {
                    this.selectedPriceGroups.splice(foundIndex, 1);
                }

                this.selectedBundle = null;
            },
            isPriceGroupActive(priceGroup) {
                let found = false;

                for (let v in this.selectedPriceGroups) {
                    if (this.selectedPriceGroups[v].id == priceGroup.id) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            selectBundle(bundle) {
                if (this.isBundleActive(bundle)) {
                    this.resetFilter();
                    return false;
                }
                this.selectedBundle = _.clone(bundle);
                this.selectedFilter = 'bundle';
                this.selectedGenres = [];
                this.selectedKeys = [];
                this.selectedMoods = [];
                this.search = '';
                // this.goToPath();
            },
            toggleBundle(bundle) {

                if (this.selectedBundle != null) {
                    if (this.selectedBundle.id == bundle.id) {
                        this.selectedBundle = null;
                    } else {
                        this.selectedBundle = _.clone(bundle);
                    }
                } else {
                    this.selectedBundle = _.clone(bundle);
                }

                this.selectedGenres = [];
                this.selectedKeys = [];
                this.selectedMoods = [];
                this.search = '';
            },
            isBundleActive(bundle) {
                if (this.selectedBundle != null) {
                    return this.selectedBundle.id == bundle.id;
                }

                return false;
            },
            toggleFilterMobile() {
                this.filterMobileVisible = !this.filterMobileVisible;
            },
            toggleSort(sortKey) {
                //if sort key is same, toggle sort direction instead
                if (this.sort == sortKey) {
                    //if sort direction is ascending, switch to descending
                    if (this.sortDirection == 'asc') {
                        this.sortDirection = 'desc';

                        //if sort direction is descending, reset sort
                    } else if(this.sortDirection == 'desc') {
                        this.sortDirection = 'asc';
                        this.sort = null;
                    }

                    //if sort key is not the same, set sort and sortDirection to ascending
                } else {
                    this.sort = sortKey;
                    this.sortDirection = 'asc';
                }
            },
            getColumnHeaderClasses(key) {
                let classes = [];

                if(this.sort == key) {
                    classes.push('sort-' + (this.sortDirection == 'asc' ? 'asc' : 'desc'));
                }

                return classes;
            },
            goToPrevPage() {
                if (this.currentPage > 1) {
                    this.fetchData(this.currentPage - 1);
                    this.scrollNextPage();
                }
            },
            goToNextPage() {
                if (this.currentPage < this.totalPages) {
                    this.fetchData(this.currentPage + 1);
                    this.scrollNextPage();
                }
            },
            scrollNextPage() {
                var offset;

                if (window.innerWidth <= 500) {
                    offset = 150;
                }
                else if (window.innerWidth > 500 && window.innerWidth <= 1500) {
                    offset = 200;
                }
                else {
                    offset = 250
                }

                const y = this.$refs.sounds.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({top: y, behavior: 'smooth'});
            },
            bundlesNextPage() {
                this.bundlesPageIndex++;
                if (this.bundlesPageIndex > this.bundlesTotalPages-1) {
                    this.bundlesPageIndex = 0;
                }
            },
            bundlesPrevPage() {
                this.bundlesPageIndex--;
                if (this.bundlesPageIndex < 0) {
                    this.bundlesPageIndex = this.bundlesTotalPages - 1;
                }
            },
            fetchData: async function(page) {

                const usePath = location.hash.replace('#','');

                let extraPath = this.$route.path.replace(/^\/|\/$/g, '');

                if (this.basePath) {
                    extraPath = extraPath.replace(this.basePath, '').replace(/^\/|\/$/g, '');
                }

                const postData = {
                    initialized: this.initialized,
                    requestPath: this.requestPath,
                    itemsPerPage: this.itemsPerPage,
                    path: usePath,
                    extraPath: extraPath,
                };

                if (this.initialized) {
                    postData.page = page;
                    // postdata.preSelectedFilter = this.preSelectedFilter;
                }

                this.$root.$emit('filterAction');

                await axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/sounds/search', postData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('search')) {
                            this.search = response.data.search;
                        }
                        if (response.data.hasOwnProperty('loggedIn')) {
                            this.loggedIn = response.data.loggedIn;
                        }
                        if (response.data.hasOwnProperty('genres')) {
                            this.genres = response.data.genres;

                            this.selectedFilter = 'genre';
                        }
                        if (response.data.hasOwnProperty('keys')) {
                            this.keys = response.data.keys;

                            if (this.selectedFilter === null) {
                                this.selectedFilter = 'key';
                            }
                        }
                        if (response.data.hasOwnProperty('moods')) {
                            this.moods = response.data.moods;

                            if (this.selectedFilter === null) {
                                this.selectedFilter = 'mood';
                            }
                        }
                        if (response.data.hasOwnProperty('priceGroups')) {
                            this.priceGroups = response.data.priceGroups;

                            if (this.selectedFilter === null) {
                                this.selectedFilter = 'pricegroups';
                            }
                        }
                        if (response.data.hasOwnProperty('bundles')) {
                            this.bundles = response.data.bundles;

                            this.highlightedBundles = [];

                            // add highlighted bundles first
                            for (let b in this.bundles) {
                                for (let h = 1; h <= 6; h++) {
                                    if (this.highlightedBundleIds[h] && this.highlightedBundleIds[h] == this.bundles[b].id) {
                                        this.highlightedBundles.push(this.bundles[b]);
                                    }
                                }
                            }

                            // then add the rest of the bundles after (but only from the visible bundles)
                            for (let b in this.visibleBundles) {
                                let found = false;

                                for (let h in this.highlightedBundles) {
                                    if (this.highlightedBundles[h].id == this.visibleBundles[b].id) {
                                        found = true;
                                    }
                                }

                                if (!found) {
                                    this.highlightedBundles.push(this.visibleBundles[b]);
                                }
                            }
                        }
                        if (response.data.hasOwnProperty('selectedGenres')) {
                            this.selectedGenres = response.data.selectedGenres;
                        }
                        if (response.data.hasOwnProperty('selectedKeys')) {
                            this.selectedKeys = response.data.selectedKeys;
                        }
                        if (response.data.hasOwnProperty('selectedMoods')) {
                            this.selectedMoods = response.data.selectedMoods;
                        }
                        if (response.data.hasOwnProperty('selectedPriceGroups')) {
                            this.selectedPriceGroups = response.data.selectedPriceGroups;
                        }
                        if (response.data.hasOwnProperty('selectedBundle')) {
                            this.selectedBundle = response.data.selectedBundle;

                            if (this.selectedBundle != null) {
                                this.selectedFilter = 'bundle';
                            }
                        }
                        if (response.data.hasOwnProperty('results')) {
                            this.results = response.data.results;
                        }
                        if (response.data.hasOwnProperty('totalItems')) {
                            this.totalItems = response.data.totalItems;
                        }
                        if (response.data.hasOwnProperty('totalPages')) {
                            this.totalPages = response.data.totalPages;
                        }
                        if (response.data.hasOwnProperty('currentPage')) {
                            this.currentPage = response.data.currentPage;
                        }
                        if (response.data.hasOwnProperty('sort')) {
                            this.sort = response.data.sort;
                        }
                        if (response.data.hasOwnProperty('sortDirection')) {
                            this.sortDirection = response.data.sortDirection;
                        }
                        if (response.data.hasOwnProperty('credits')) {
                            this.credits = response.data.credits;
                        }
                        if (response.data.hasOwnProperty('registerUrl')) {
                            this.registerUrl = response.data.registerUrl;
                        }
                        if (response.data.hasOwnProperty('path')) {
                            let usePath = this.$route.path.replace(/^\/|\/$/g, '');

                            if (this.basePath) {
                                usePath = usePath.replace(this.basePath, '').replace(/^\/|\/$/g, '');
                            }
                            if (usePath != response.data.path) {
                                router.push((this.basePath ? '/' + this.basePath : '') + '/' + response.data.path);
                            }
                        }
                    })
                    .catch(() => {

                    });
                this.expandedJingles = [];
                this.initialized = true;
                this.requestPath = false;

                const currentRobotsElement = document.querySelector("[name='ROBOTS']");

                if (!currentRobotsElement || !currentRobotsElement.hasAttribute('data-update') || currentRobotsElement.getAttribute('data-update') == '1') {
                    if (this.$route.path == '/' + this.basePath) {
                        if (currentRobotsElement) {
                            currentRobotsElement.remove();
                        }
                    } else {
                        if (this.preSelectedFilter) {
                            let checkPath = this.$route.path.replace(/^\/|\/$/g, '');

                            if (this.basePath) {
                                checkPath = checkPath.replace(this.basePath, '').replace(/^\/|\/$/g, '');
                            }

                            if (checkPath == this.preSelectedFilter) {
                                if (currentRobotsElement) {
                                    currentRobotsElement.remove();
                                }
                            } else {
                                if (currentRobotsElement) {
                                    currentRobotsElement.content = 'NOINDEX, NOFOLLOW';
                                } else {
                                    const element = document.createElement('meta');
                                    element.name = 'ROBOTS';
                                    element.content = 'NOINDEX, NOFOLLOW';
                                    document.head.appendChild(element);
                                }
                            }
                        } else {
                            if (currentRobotsElement) {
                                currentRobotsElement.content = 'NOINDEX, NOFOLLOW';
                            } else {
                                const element = document.createElement('meta');
                                element.name = 'ROBOTS';
                                element.content = 'NOINDEX, NOFOLLOW';
                                document.head.appendChild(element);
                            }
                        }
                    }
                }
            }
        },
        computed: {
            visibleBundles() {
                return this.bundles.filter(bundle => !bundle.invisible);
            },
            watchValue() {
		      return JSON.stringify(this.selectedBundle) + '|' + JSON.stringify(this.selectedGenres) + '|' + JSON.stringify(this.selectedKeys) + '|' + JSON.stringify(this.selectedMoods) + '|' + JSON.stringify(this.selectedPriceGroups) + `|${this.sort}|${this.sortDirection}`;
            },
            selectedBundleOwnedItems() {
                let owned = [];

                for (let r in this.results) {
                    if (this.results[r].owned) {
                        owned.push(this.results[r]);
                    }
                }

                return owned;
            },
            selectedBundleNotOwnedItems() {
                let notOwned = [];

                for (let r in this.results) {
                    if (!this.results[r].owned) {
                        notOwned.push(this.results[r]);
                    }
                }

                return notOwned;
            },
            selectedBundlePrice() {
                if (this.selectedBundle == null) {
                    return 0;
                }

                let totalPrice = 0;

                for (let r in this.results) {
                    totalPrice += this.results[r].credits;
                }

                totalPrice -= totalPrice * (this.selectedBundle.discount/100);

                return Math.ceil(totalPrice);
            },
            selectedBundlePriceWithoutOwned() {
                if (this.selectedBundle == null) {
                    return 0;
                }

                let totalPrice = 0;

                for (let r in this.results) {
                    if (this.results[r].owned) {
                        continue;
                    }

                    totalPrice += this.results[r].credits;
                }

                totalPrice -= totalPrice * (this.selectedBundle.discount/100);

                if (totalPrice < 0) {
                    totalPrice = 0;
                }

                return Math.ceil(totalPrice);
            },
            genreLookup() {
                var lookup = {};

                for(var i in this.genres) {
                    var genre = this.genres[i];

                    lookup[genre.id] = genre;
                }

                return lookup;
            },
            shownBundles() {
                // return the bundles of the current page
                return this.highlightedBundles.slice(this.bundlesPageIndex * this.bundlesPerPage, this.bundlesPageIndex * this.bundlesPerPage + this.bundlesPerPage);
            },
            bundlesTotalPages() {
                // return the total amount of pages
                return Math.ceil(this.highlightedBundles.length / this.bundlesPerPage);
            },
        },
        mounted: async function() {
            this.$root.$on('updateCredits', (credits) => {
                this.credits = credits;
            });
            this.$root.$on('toggleGenre', genreId => {
                var genre = this.genreLookup[genreId] || null;

                if (!genre) {
                    return false;
                }

                this.toggleGenre(genre);
            })

            if (this.preSelectedFilter) {
                if (window.location.hash == '') {
                    await router.push((this.basePath ? '/' + this.basePath : '') + '#' + this.preSelectedFilter);
                }
            }

            await this.fetchData();

            if (this.loggedIn) {
                if (localStorage.getItem('buySoundAfterLogin')) {
                    let foundResult = null;
                    let resultId = null;
                    let childId = null;

                    resultloop:
                    for (let result of this.results) {
                        if (result.id == localStorage.getItem('buySoundAfterLogin')) {
                            foundResult = result;
                            resultId = result.id;
                            break;
                        }

                        if (result.children) {
                            for (let child of result.children) {
                                if (child.id == localStorage.getItem('buySoundAfterLogin')) {
                                    foundResult = result;
                                    resultId = result.id;
                                    childId = child.id;
                                    break resultloop;
                                }
                            }
                        }
                    }
                    if (childId) {
                        this.toggleSoundExpand(foundResult);
                        this.buyVariant(resultId, childId);
                    } else {
                        this.buy(localStorage.getItem('buySoundAfterLogin'));
                    }

                    const el = document.getElementById('sound-result-item-' + resultId);

                    if (el) {
                        const y = el.getBoundingClientRect().top + window.pageYOffset - 200;

                        window.scrollTo({top: y, behavior: 'smooth'});
                    }
                }

                localStorage.removeItem('buySoundAfterLogin', null);
            }
        },
    }

</script>
